import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

export const AccessDenied: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleGoHome = () => {
    navigate('/');
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-b from-gray-900 to-black z-[9999]">
      {/* Logo */}
      <Link
        to="/companions"
        className="fixed top-[28px] left-6 h-8 w-auto opacity-100 z-[99999]">
        <img
          src="/assets/images/logo_napster_white.svg"
          alt="Napster"
          className="h-8"
        />
      </Link>
      <div className="text-center px-4">
        {/* Lock Icon */}
        <div className="mb-6">
          <svg
            className="w-24 h-24 mx-auto text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm6-10V7a3 3 0 00-6 0v4h6z"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-white mb-2">{t('generation.accessDenied')}</h1>

        {/* Description */}
        <p className="text-lg text-gray-300 mb-2">
          {t('generation.noPermission')}
        </p>
        <p className="text-sm text-gray-400 mb-8">
          {t('generation.noPermissionDetails')}
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleGoHome}
            className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors duration-200">
            {t('generation.goHome')}
          </button>
        </div>
      </div>
    </div>
  );
};
